import { render, staticRenderFns } from "./EditarPerfil.vue?vue&type=template&id=155777ac&scoped=true"
import script from "./EditarPerfil.vue?vue&type=script&lang=js"
export * from "./EditarPerfil.vue?vue&type=script&lang=js"
import style0 from "./EditarPerfil.vue?vue&type=style&index=0&id=155777ac&prod&lang=scss"
import style1 from "./EditarPerfil.vue?vue&type=style&index=1&id=155777ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155777ac",
  null
  
)

export default component.exports